import TermsOfService from '../components/TermsOfService.vue';

export default [
  {
    path: '',
    redirect: 'terms-of-service',
    meta: {
      role: ['User'],
    },
  },
  {
    path: 'terms-of-service',
    component: TermsOfService,
    meta: {
      title: 'Terms of Service',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/licensing',
          title: 'Licensing',
        },
        {
          path: '',
          title: 'Terms of Service',
        },
      ],
    },
  },
];
